export default __webpack_public_path__ + "static/media/1780.a65f2e5c.png";